<template>
    <g>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M49.4,45.1c0-0.1-0.5-0.7-0.8-1c-1.5-1.3-2.8-1.4-4.4-0.9c-1.7,0.6-2.4,1.9-2.5,1.9c0.1,0,1.4-1,3.2-1.3
			c-0.5,0.2-0.8,0.5-0.8,1.1c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-0.7-0.5-1.1-1.1-1.2C47.2,43.8,48.3,44.1,49.4,45.1z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M63.8,43.2c-1.5-0.5-2.9-0.4-4.4,0.9c-0.3,0.3-0.8,0.9-0.8,1c1.1-1,2.3-1.3,3.4-1.3c-0.6,0.1-1.1,0.5-1.1,1.2
			c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-0.5-0.3-0.9-0.7-1.1c1.8,0.3,3.1,1.3,3.1,1.3C66.2,45.1,65.5,43.8,63.8,43.2z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M49.6,38c-0.3-0.1-0.5-0.1-0.8-0.1c-0.8-0.1-1.6-0.1-2.3,0c-1.6,0.1-2.7,0.2-4.2,0.7
			c-0.4,0.1-0.7,0.5-0.9,0.9c-0.3,0.4-1.4,2.2-1.3,2.6c0,0.2,0.2,0.4,0.4,0.2c0.5-0.4,1.1-1,1.6-1.3c0.3-0.2,0.5-0.4,0.9-0.5
			c1.8-0.3,3.7-0.4,5.6-0.3c0.6,0,1.2,0.1,1.8,0.1c0.2,0,0.7,0.1,0.7,0.1c0.2-0.2-0.5-1.6-1-2.1C49.9,38,49.7,38,49.6,38z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M66.9,39.3c-0.2-0.3-0.5-0.7-0.8-0.8c-1.5-0.4-2.8-0.6-4.4-0.7c-0.8,0-1.6-0.1-2.4,0c-0.3,0-0.9,0-1.1,0.2
			c-0.5,0.5-1.2,2-1,2.1c0,0,0.4,0,0.7-0.1c0.6-0.1,1.2-0.1,1.9-0.1c1.9-0.1,3.8,0,5.6,0.3c0.4,0.1,0.9,0.2,1.2,0.4
			c0.5,0.4,0.7,1,1.2,1.4c0.2,0.2,0.4,0.1,0.4-0.2C68.1,41.6,67.2,39.7,66.9,39.3z"/>
    </g>
</template>

<script>
    export default {
        name: 'Eye11',
    }
</script>
